<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="mt-8" no-gutters>
        <div id="canvas-wrapper" class="d-none" />

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="qrType"
              :items="types"
              append-icon="mdi-image-outline"
              dense
              class="contentinfo"
              :label="$t('format')"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-qrType`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('format')"
            />
          </div>
        </v-col>

        <v-col v-if="qrType !== 'selectable'" class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="qrSize"
              :items="sizes"
              append-icon="mdi-format-list-bulleted-type"
              dense
              class="contentinfo"
              :label="$t('output_size')"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-qrSize`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('output_size')"
            />
          </div>
        </v-col>

        <v-col v-else class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-autocomplete
              v-model="extension"
              :items="multipleType"
              append-icon="mdi-export"
              dense
              class="contentinfo"
              :label="$t('file_type')"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-extension`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('file_type')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12">
          <div class="rowinfo">
            <v-btn
              :loading="loading"
              class="btn-download ma-0"
              @click="downloadFile"
            >
              <v-icon class="me-2">mdi-progress-download</v-icon>
              {{ $t("download") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('download')"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QRCodeStyling from "qr-code-styling";
import { writePsd } from "ag-psd";
import Drawing from "dxf-writer";

export default {
  name: "downloadFile",
  props: {
    info: {
      type: Object,
      required: true,
    },
    visitName: {
      type: String,
      default: "qr",
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "downloadFile",
      types: [
        { text: "SVG", value: "svg" },
        { text: "PNG", value: "png" },
        { text: "JPEG", value: "jpeg" },
        { text: "WEBP", value: "webp" },
        { text: "PSD", value: "psd" },
        { text: "DXF", value: "dxf" },
        { text: "600*600", value: "selectable" },
      ],
      qrSize: "default",
      qrType: "svg",
      extension: "svg",
      loading: false,
    };
  },
  computed: {
    sizes() {
      return [
        { text: this.$t("default"), value: "default" },
        { text: "100", value: "100" },
        { text: "200", value: "200" },
        { text: "300", value: "300" },
        { text: "400", value: "400" },
        { text: "500", value: "500" },
        { text: "600", value: "600" },
        { text: "700", value: "700" },
        { text: "800", value: "800" },
        { text: "900", value: "900" },
        { text: "1000", value: "1000" },
      ];
    },
    getVisitName() {
      let str = this.qrSize !== "default" ? `-${this.qrSize}` : "";
      return this.visitName.replace(/\s+/g, "_") + str;
    },
    multipleType() {
      return this.types.filter((item) => item.value !== "selectable");
    },
    computedFormat() {
      return this.qrType === "selectable" ? this.extension : this.qrType;
    },
  },
  methods: {
    downloadBlob(blob, filename) {
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    },
    async saveAsPsd(canvas, fileName) {
      const psd = {
        width: canvas.width,
        height: canvas.height,
        children: [
          {
            name: "Background",
            canvas: canvas,
          },
        ],
      };
      const buffer = writePsd(psd);
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      this.downloadBlob(blob, `${fileName}.psd`);
    },
    async saveAsDxf(canvas, size, fileName) {
      const d = new Drawing();
      d.setUnits("Pixels");

      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, size, size);
      const data = imgData.data;

      const step = 2; // برای کاهش حجم فایل و جلوگیری از افت سرعت می‌توانید 2 یا 3 بگذارید. (1 = حداکثر دقت)

      for (let y = 0; y < size; y += step) {
        for (let x = 0; x < size; x += step) {
          const index = (y * size + x) * 4;
          const r = data[index];
          const g = data[index + 1];
          const b = data[index + 2];
          const a = data[index + 3];

          // بررسی تیره بودن و عدم شفافیت پیکسل
          if (a > 128 && (r + g + b) / 3 < 128) {
            d.drawRect(x, -y, x + step, -(y + step));
          }
        }
      }

      const dxfString = d.toDxfString();
      const blob = new Blob([dxfString], { type: "application/dxf" });
      this.downloadBlob(blob, `${fileName}.dxf`);
    },
    async downloadSvgFromUrl() {
      const svgUrl =
        this.info?.img_url || this.info?.image || this.info.data?.data?.image;
      const fileName = this.getVisitName || "qr";
      const extension = this.computedFormat || "svg";
      const size = this.qrSize !== "default" ? Number(this.qrSize) : 300;

      if (!svgUrl) {
        throw new Error("آدرس SVG نامعتبر یا وجود ندارد");
      }

      try {
        let text = "";

        if (svgUrl.startsWith("data:image/svg+xml;base64,")) {
          const base64Data = svgUrl.replace("data:image/svg+xml;base64,", "");
          text = decodeURIComponent(escape(window.atob(base64Data)));
        } else {
          const response = await fetch(
            `${this.$qrApi}/convert?file_path=${this.info.image}`,
          );
          if (!response.ok) {
            throw new Error(
              `خطای HTTP! وضعیت: ${response.status}, متن: ${response.statusText}`,
            );
          }
          text = await response.text();
        }

        if (extension === "svg") {
          text = text.replace(/<svg([^>]*)width="[^"]*"([^>]*)>/, `<svg$1$2>`);
          text = text.replace(/<svg([^>]*)height="[^"]*"([^>]*)>/, `<svg$1$2>`);
          text = text.replace(
            /<svg([^>]*)>/,
            `<svg$1 width="${size}" height="${size}">`,
          );
          const svgBlob = new Blob([text], { type: "image/svg+xml" });
          this.downloadBlob(svgBlob, `${fileName}.svg`);
        } else {
          const svgBlob = new Blob([text], { type: "image/svg+xml" });
          const url = window.URL.createObjectURL(svgBlob);

          const img = new Image();
          img.crossOrigin = "anonymous";

          const loadImage = () =>
            new Promise((resolve, reject) => {
              const timeout = setTimeout(
                () => reject(new Error("تایم‌اوت بارگذاری تصویر")),
                5000,
              );
              img.onload = () => {
                clearTimeout(timeout);
                resolve(img);
              };
              img.onerror = () => {
                clearTimeout(timeout);
                reject(new Error(`بارگذاری SVG از ${url} ناموفق بود`));
              };
              img.src = url;
            });

          await loadImage();

          const canvas = document.createElement("canvas");
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, size, size);

          if (extension === "psd") {
            await this.saveAsPsd(canvas, fileName);
            this.$toast.success(this.$t("qr_downloaded_successfully"));
          } else if (extension === "dxf") {
            await this.saveAsDxf(canvas, size, fileName);
            this.$toast.success(this.$t("qr_downloaded_successfully"));
          } else {
            const mimeType =
              {
                png: "image/png",
                jpeg: "image/jpeg",
                webp: "image/webp",
              }[extension] || "image/png";

            canvas.toBlob(
              (blob) => {
                this.downloadBlob(blob, `${fileName}.${extension}`);
              },
              mimeType,
              1.0,
            );
            this.$toast.success(this.$t("qr_downloaded_successfully"));
          }
          window.URL.revokeObjectURL(url);
        }
      } catch (error) {
        this.$toast.error(this.$t("qr_download_error") + ": " + error.message);
        await this.generateLocalQrFallback();
      } finally {
        this.loading = false;
      }
    },

    async generateLocalQrFallback() {
      const sanitizeFileName = (name) => {
        if (!name || typeof name !== "string" || name.trim() === "") {
          return "qr";
        }
        return name.replace(/\s+/g, "_").replace(/_+/g, "_").trim() || "qr";
      };
      const fileName = sanitizeFileName(this.getVisitName);
      const extension = this.computedFormat || "png";
      const size = this.qrSize !== "default" ? Number(this.qrSize) : 300;

      const byteCapacities = [
        [17, 14, 11, 7],
        [32, 26, 20, 14],
        [53, 42, 32, 24],
        [78, 62, 46, 34],
        [106, 84, 60, 44],
        [134, 106, 74, 58],
        [154, 122, 86, 64],
        [192, 152, 108, 84],
        [230, 180, 130, 98],
        [271, 213, 151, 119],
        [321, 251, 177, 137],
        [367, 287, 203, 155],
        [425, 331, 241, 177],
        [458, 362, 258, 194],
        [520, 412, 292, 220],
        [586, 450, 322, 250],
        [644, 504, 364, 280],
        [718, 560, 394, 310],
        [792, 624, 442, 338],
        [858, 666, 482, 382],
        [929, 711, 509, 403],
        [1003, 779, 565, 439],
        [1091, 857, 611, 461],
        [1171, 911, 661, 511],
        [1273, 997, 715, 535],
        [1367, 1059, 751, 593],
        [1465, 1125, 805, 625],
        [1528, 1190, 868, 658],
        [1628, 1264, 908, 698],
        [1732, 1370, 982, 742],
        [1840, 1452, 1030, 790],
        [1952, 1538, 1112, 842],
        [2068, 1628, 1168, 898],
        [2188, 1722, 1228, 958],
        [2303, 1809, 1283, 983],
        [2431, 1911, 1351, 1051],
        [2563, 1989, 1423, 1093],
        [2699, 2099, 1499, 1139],
        [2809, 2213, 1579, 1219],
        [2953, 2331, 1663, 1273],
      ];

      const alphaCapacities = [
        [25, 20, 16, 10],
        [47, 38, 29, 20],
        [77, 61, 47, 35],
        [114, 90, 67, 50],
        [154, 122, 87, 64],
        [195, 154, 108, 84],
        [224, 178, 125, 93],
        [279, 221, 157, 122],
        [335, 262, 189, 143],
        [395, 311, 221, 174],
        [468, 366, 259, 200],
        [535, 419, 296, 227],
        [619, 483, 352, 259],
        [667, 528, 376, 283],
        [758, 600, 426, 321],
        [854, 656, 470, 365],
        [938, 734, 531, 408],
        [1046, 816, 574, 452],
        [1153, 909, 644, 493],
        [1249, 970, 702, 557],
        [1352, 1035, 742, 587],
        [1460, 1134, 823, 640],
        [1588, 1248, 890, 672],
        [1704, 1326, 963, 744],
        [1853, 1451, 1041, 779],
        [1990, 1542, 1094, 864],
        [2132, 1637, 1172, 910],
        [2223, 1732, 1263, 958],
        [2369, 1839, 1322, 1016],
        [2520, 1994, 1429, 1080],
        [2677, 2113, 1499, 1150],
        [2840, 2238, 1618, 1226],
        [3009, 2369, 1700, 1307],
        [3183, 2506, 1787, 1394],
        [3351, 2632, 1867, 1431],
        [3537, 2780, 1966, 1530],
        [3729, 2894, 2071, 1591],
        [3927, 3054, 2181, 1658],
        [4087, 3220, 2298, 1774],
        [4296, 3391, 2420, 1852],
      ];

      const numericCapacities = [
        [41, 34, 27, 17],
        [77, 63, 48, 34],
        [127, 101, 77, 58],
        [187, 149, 111, 82],
        [255, 202, 144, 106],
        [322, 255, 178, 139],
        [370, 293, 207, 154],
        [461, 365, 259, 202],
        [552, 432, 312, 235],
        [652, 513, 364, 288],
        [772, 604, 427, 331],
        [883, 691, 489, 374],
        [1022, 796, 580, 427],
        [1101, 871, 621, 468],
        [1250, 991, 703, 530],
        [1408, 1082, 775, 602],
        [1548, 1212, 876, 674],
        [1725, 1346, 948, 746],
        [1903, 1500, 1063, 813],
        [2061, 1600, 1159, 919],
        [2232, 1708, 1224, 969],
        [2409, 1872, 1358, 1056],
        [2620, 2059, 1468, 1108],
        [2812, 2188, 1588, 1228],
        [3057, 2395, 1718, 1286],
        [3283, 2544, 1804, 1425],
        [3517, 2701, 1933, 1501],
        [3669, 2857, 2085, 1581],
        [3909, 3035, 2181, 1677],
        [4158, 3289, 2358, 1782],
        [4417, 3486, 2473, 1897],
        [4686, 3693, 2670, 2022],
        [4965, 3909, 2805, 2157],
        [5253, 4134, 2949, 2301],
        [5529, 4343, 3081, 2361],
        [5836, 4588, 3244, 2524],
        [6153, 4775, 3417, 2625],
        [6479, 5039, 3599, 2735],
        [6743, 5313, 3791, 2927],
        [7089, 5596, 3993, 3057],
      ];

      const levels = ["L", "M", "Q", "H"];

      const getDataLength = (data, mode) => {
        if (!data || typeof data !== "string") return 0;
        if (mode === "Numeric" || mode === "Alphanumeric") return data.length;
        if (mode === "Byte") return new TextEncoder().encode(data).length;
        return data.length;
      };

      const getCalculatedTypeNumber = (length) => {
        if (length <= 20) return 2;
        if (length <= 50) return 4;
        if (length <= 100) return 10;
        if (length <= 200) return 15;
        if (length <= 300) return 20;
        if (length <= 400) return 25;
        if (length <= 500) return 30;
        return 40;
      };

      const getCalculatedErrorLevelIndex = (length) => {
        if (length <= 50) return 0;
        if (length <= 100) return 1;
        if (length <= 500) return 2;
        return 3;
      };

      const getOptimalConfig = (
        data,
        userTypeNumber,
        userErrorLevel,
        userMode,
      ) => {
        if (!data || typeof data !== "string") {
          return { typeNumber: 4, errorCorrectionLevel: "L", mode: userMode };
        }

        const dataLength = getDataLength(data, userMode);
        const capacities =
          userMode === "Numeric"
            ? numericCapacities
            : userMode === "Alphanumeric"
            ? alphaCapacities
            : byteCapacities;

        const calcType = getCalculatedTypeNumber(dataLength);
        let finalType = Math.max(userTypeNumber || calcType, calcType);

        const calcLevelIndex = getCalculatedErrorLevelIndex(dataLength);
        const userLevelIndex = userErrorLevel
          ? levels.indexOf(userErrorLevel)
          : -1;

        let selectedLevelIndex = -1;
        for (let i = 3; i >= 0; i--) {
          const cap = capacities[finalType - 1][i];
          if (cap >= dataLength) {
            if (
              userLevelIndex >= i &&
              capacities[finalType - 1][userLevelIndex] >= dataLength
            ) {
              selectedLevelIndex = userLevelIndex;
              break;
            } else {
              selectedLevelIndex = i;
              break;
            }
          }
        }

        if (selectedLevelIndex === -1) {
          let increasedType = Math.min(finalType + 5, 40);
          while (increasedType <= 40 && selectedLevelIndex === -1) {
            for (let i = 3; i >= 0; i--) {
              const cap = capacities[increasedType - 1][i];
              if (cap >= dataLength) {
                selectedLevelIndex = i;
                finalType = increasedType;
                break;
              }
            }
            increasedType += 5;
          }
          if (selectedLevelIndex === -1) {
            throw new Error(
              "No suitable configuration found for the data length",
            );
          }
        }

        return {
          typeNumber: finalType,
          errorCorrectionLevel: levels[selectedLevelIndex],
          mode: userMode,
        };
      };

      try {
        let qrConfig = {};
        let data = "";
        if (this.info && this.info.qr) {
          qrConfig =
            typeof this.info.qr === "string"
              ? JSON.parse(this.info.qr)
              : this.info.qr;
          data = this.info.qr.data;

          const userTypeNumber = qrConfig.qrOptions?.typeNumber;
          const userErrorLevel =
            qrConfig.qrOptions?.errorCorrectionLevel || "Q";
          const userMode = qrConfig.qrOptions?.mode || "Byte";

          const optimal = getOptimalConfig(
            data,
            userTypeNumber,
            userErrorLevel,
            userMode,
          );
          qrConfig.qrOptions = {
            ...qrConfig.qrOptions,
            typeNumber: optimal.typeNumber,
            mode: optimal.mode,
            errorCorrectionLevel: optimal.errorCorrectionLevel,
          };
        } else {
          data = this.info.qr.data;
          const optimal = getOptimalConfig(data, null, null, "Byte");
          qrConfig = {
            width: size,
            height: size,
            data: data,
            image: this.info.data?.data?.image || null,
            margin: 5,
            qrOptions: {
              typeNumber: optimal.typeNumber,
              mode: optimal.mode,
              errorCorrectionLevel: optimal.errorCorrectionLevel,
            },
            dotsOptions: {
              type: "circle",
              color: "#6a1a4c",
              gradient: null,
            },
            backgroundOptions: {
              color: "#FFFFFFFF",
              gradient: null,
            },
            imageOptions: {
              hideBackgroundDots: true,
              imageSize: 0.4,
              margin: 0,
            },
            cornersSquareOptions: {
              type: "extra-rounded",
              color: "#690a70",
              gradient: null,
            },
            cornersDotOptions: {
              type: "",
              color: "#b00cab",
              gradient: null,
            },
          };
        }

        if (this.qrType === "selectable") {
          qrConfig = { ...qrConfig, width: 600, height: 600 };
        }
        
        const usedExtension = (extension === "psd" || extension === "dxf") ? "png" : extension;

        qrConfig = {
          ...qrConfig,
          width: size,
          height: size,
          type: usedExtension,
          data: data,
        };

        const qrCode = new QRCodeStyling(qrConfig);
        const canvasWrapper = document.getElementById("canvas-wrapper");
        if (!canvasWrapper) {
          throw new Error("Canvas wrapper not found in DOM");
        }
        
        qrCode.append(canvasWrapper);
        await this.$nextTick();
        
        if (extension === "psd" || extension === "dxf") {
          const rawData = await qrCode.getRawData("png");
          const img = new Image();
          const url = window.URL.createObjectURL(rawData);
          
          img.onload = async () => {
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, size, size);
            
            if (extension === "psd") {
              await this.saveAsPsd(canvas, fileName);
            } else {
              await this.saveAsDxf(canvas, size, fileName);
            }
            
            window.URL.revokeObjectURL(url);
            this.$toast.success(this.$t("qr_downloaded_successfully"));
          };
          img.src = url;
        } else {
          await qrCode.download({
            name: fileName,
            extension: extension,
          });
          this.$toast.success(this.$t("qr_downloaded_successfully"));
        }
      } catch (error) {
        this.$toast.error(this.$t("qr_download_error") + ": " + error.message);
      }
    },
    async downloadFile() {
      this.loading = true;
      try {
        if (this.info?.data?.data?.tab_design === 1 || this.info?.img_url) {
          await this.downloadSvgFromUrl();
        } else {
          await this.generateLocalQrFallback();
        }
      } catch (error) {
        this.$toast.error(this.$t("qr_download_error") + ": " + error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.d-none {
  display: none;
}
.rowinfo {
  display: flex;
  align-items: center;
}
.contentinfo {
  flex: 1;
}
.buttoninfo {
  margin-left: 8px;
}
.btn-download {
  text-transform: none;
}
</style>
